<!-- 6. PROYECTOS -->
<div class="projects-section" id="proyectos">
  <!-- Encabezado: mismo patrón que "Quiénes te acompañan" (título + párrafo centrados) -->
  <header class="projects-head">
    <h2 id="titulo-proyecto" class="section-title2" appRevealOnScroll>Tenemos estos servicios para ti</h2>
    <p class="projects-lead">
      Agenda tu cita virtual o adquiere recursos digitales para acompañar tu proceso
      a tu ritmo, desde donde estés.
    </p>
  </header>

  <!-- Loader mientras se cargan los productos del backend -->
  <div class="loader-wrapper" *ngIf="isLoading">
    <div class="loader">
      <div class="cup">
        <div class="cup-handle"></div>
        <div class="smoke one"></div>
        <div class="smoke two"></div>
        <div class="smoke three"></div>
      </div>
      <div class="load">..........................</div>
    </div>
  </div>

  <div class="projects-container" *ngIf="!isLoading">
    <!-- Detalle del proyecto -->
    <div class="project-detail" *ngIf="selectedProject" [@projectTransition]="selectedProject">

      <!-- Icono tipo (sesión o producto) — posición absoluta sobre la imagen -->
      <div class="type-badge big" [ngClass]="selectedProject.type.code">
        <i class="fas" [ngClass]="selectedProject.type.code === 'libro' ? 'fa-shopping-bag' : 'fa-calendar-check'"></i>
      </div>

      <img [src]="selectedProject.image" alt="Detalle proyecto">

      <div class="detail-pricing">
        <span class="detail-price-value">{{ selectedProject.price | copCurrency }}</span>
        <span class="detail-price-label" *ngIf="selectedProject.type.code === 'consulta'">&nbsp;/ sesión</span>
      </div>

      <div class="detail-inner">

        <!-- Header: tipo + título -->
        <div class="detail-header">
          <span class="detail-type-badge" [ngClass]="selectedProject.type.code">
            <i class="fas" [ngClass]="selectedProject.type.code === 'libro' ? 'fa-shopping-bag' : 'fa-calendar-check'"></i>
            {{ selectedProject.type.code === 'libro' ? 'Producto digital' : 'Sesión virtual' }}
          </span>
          <h3 class="detail-title">{{ selectedProject.name }}</h3>
          <p class="detail-short">{{ selectedProject.short }}</p>
        </div>

        <!-- Descripción -->
        <p class="detail-description">{{ selectedProject.description }}</p>

        <!-- Features list -->
        <ul class="detail-features">
          <li *ngFor="let feature of selectedProject.features">
            <span class="feature-icon">
              <svg height="14" width="14" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0h24v24H0z" fill="none"></path>
                <path fill="currentColor" d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
              </svg>
            </span>
            <span>{{ feature }}</span>
          </li>
        </ul>

        <!-- Acción -->
        <div class="detail-action">
          <a [href]="getWhatsappLink(selectedProject)" target="_blank" class="detail-btn-secondary">
            <i class="fab fa-whatsapp"></i>
            Preguntar por WhatsApp
          </a>
          <a href="#" (click)="viewProductDetail(selectedProject, $event)" class="detail-btn">
            <i class="fas" [ngClass]="selectedProject.type.code === 'libro' ? 'fa-shopping-cart' : 'fa-calendar-check'"></i>
            {{ selectedProject.type.code === 'libro' ? 'Comprar ahora' : 'Agendar sesión' }}
          </a>
        </div>

      </div>
    </div>

    <!-- Lista de proyectos -->
    <div class="projects-list">
      <div class="services-index" aria-label="Indice de tipos de servicio">
        <span class="index-item">
          <span class="index-icon servicio">
            <i class="fas fa-calendar-check"></i>
          </span>
          Sesión Virtual
        </span>
        <span class="index-divider"></span>
        <span class="index-item">
          <span class="index-icon producto">
            <i class="fas fa-shopping-bag"></i>
          </span>
          Producto Digital
        </span>
      </div>

      <!-- Mosaico de tarjetas: el marco claro y las líneas entre tarjetas
           pertenecen a este contenedor, no a cada tarjeta. En celular es una
           sola columna de 3 tarjetas por página; también se puede deslizar.
           Con varias páginas, el mosaico reserva siempre las filas de una página
           completa: una última página incompleta deja huecos vacíos en vez de
           estirar sus tarjetas. -->
      <div class="cards-grid" [ngClass]="'dir-' + pageDirection"
        [class.is-paged]="totalPages > 1"
        (touchstart)="onGridTouchStart($event)" (touchend)="onGridTouchEnd($event)">
        <div class="project-card" *ngFor="let project of pagedProjects; let i = index"
          role="button" tabindex="0"
          (click)="goToProjectSection(project)"
          (keydown.enter)="goToProjectSection(project)"
          (keydown.space)="goToProjectSection(project); $event.preventDefault()"
          [class.active]="selectedProject === project"
          [attr.aria-pressed]="selectedProject === project"
          [style.animation-delay]="i * 0.07 + 's'">

          <div class="project-image">
            <img [src]="project.image" [alt]="project.name" loading="lazy">

            <div class="type-badge" [ngClass]="project.type.code">
              <i class="fas" [ngClass]="project.type.code === 'libro' ? 'fa-shopping-bag' : 'fa-calendar-check'"></i>
            </div>

            <div class="overlay">
              <h3 [title]="project.name">{{ project.name }}</h3>
              <p>{{ project.short }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Paginación -->
      <nav class="projects-pagination" *ngIf="totalPages > 1" aria-label="Paginación de servicios">
        <button type="button" class="pagination-arrow" (click)="prevPage()"
          [disabled]="currentPage === 1" aria-label="Página anterior">
          <i class="fas fa-chevron-left"></i>
        </button>

        <div class="pagination-pages">
          <ng-container *ngFor="let page of visiblePages; trackBy: trackByIndex">
            <span class="pagination-ellipsis" *ngIf="page === '...'">…</span>
            <button type="button" class="pagination-page" *ngIf="page !== '...'"
              [class.active]="page === currentPage"
              [attr.aria-current]="page === currentPage ? 'page' : null"
              (click)="goToPage(page)">
              {{ page }}
            </button>
          </ng-container>
        </div>

        <button type="button" class="pagination-arrow" (click)="nextPage()"
          [disabled]="currentPage === totalPages" aria-label="Página siguiente">
          <i class="fas fa-chevron-right"></i>
        </button>
      </nav>

    </div>
  </div>
</div>